<template>
    <VJoyWrapper direction="column" row-gap="4" align="flex-start">
        <!-- Text and link to invoicing detail -->
        <div>
            <VJoyLabel>{{ $t('projectclient.billinginformation.invoice.billing.contact') }}</VJoyLabel>
            <span data-testid="billing-information-contact-email-readonly">
                {{ [billingInfos.billingContact, ...(billingInfos.otherBillingContacts ?? [])].join(', ') }}
            </span>
        </div>
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {useTranslation} from '#imports';
    import {VJoyLabel, VJoyWrapper} from '@maltjoy/core-vue';
    import type {ClientCompanyBillingInfoParam, ProjectValidationParam} from '~/openapi';

    const props = defineProps<{
        billingInfos: ClientCompanyBillingInfoParam & ProjectValidationParam;
        companyId: string;
    }>();
</script>
